(ns dashboard.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::route
 (fn [db]
   (:route db)))

(rf/reg-sub
 ::route-parameters
 :<- [::route]
 (fn [route]
   (:parameters route)))

(rf/reg-sub
 ::view.page-heading
 :<- [::route]
 (fn [route]
   (get-in route [:data :page :texts :heading])))

(rf/reg-sub
 ::view.data
 :<- [::route]
 (fn [route]
   (get route :data)))

(rf/reg-sub
 ::ui
 (fn [db]
   (:ui db)))

(rf/reg-sub
 ::ui.show-menu?
 :<- [::ui]
 (fn [ui]
   (get ui :show-menu?)))

(rf/reg-sub
 ::error
 :<- [::ui]
 (fn [ui]
   (get ui :error)))

(rf/reg-sub
 ::user
 (fn [db]
   (:user db)))

(rf/reg-sub
 ::user-preferences
 :<- [::user]
 (fn [user]
   (:preferences user)))

(rf/reg-sub
 ::app.initialized
 :<- [::ui]
 (fn [ui]
   (get ui :initialized)))

(rf/reg-sub
 ::notifications
 (fn [db]
   (:notifications db)))

(rf/reg-sub
 ::app.notifications
 :<- [::notifications]
 (fn [notifications]
   (get notifications :items)))

(rf/reg-sub
 ::ui.modals
 :<- [::ui]
 (fn [ui]
   (get ui :modal)))

(rf/reg-sub
 ::features-enabled
 :<- [::user]
 (fn [user]
   (get user :features_enabled)))

(rf/reg-sub
 ::feature-enabled
 :<- [::features-enabled]
 (fn [features-enabled [_ feature]]
   (contains? features-enabled feature)))
